<template>
  <div>
    <draggable
      class="dragArea"
      tag="ul"
      :list="tasks"
      :group="{ name: 'g1' }"
      @change="MenuTopId($event)"
      maxDepth="4"
    >
      <li v-for="(el, index) in tasks" :key="index" class="mt-2 list-unstyled">
        <div class="bg-secondary row">
          <div class="col-md-10">
            <h5 class="text-white mt-2">
              <i class="mdi mdi-plus-thick" v-if="el.Children.length > 0"></i>
              <span class="d-none"> {{ (el.Topid = TopId) }}</span>
              {{ el.Title }}
            </h5>
          </div>
          <div class="col-md-2">
            <b-button-group class="float-end">
              <b-button
                variant="success"
                v-b-modal="'menus' + el.Id"
                @click="Guncelle(el.Id)"
                ><i class="far fa-edit"></i>
              </b-button>
              <b-button variant="danger" @click="Delete('menus', el.Id)"
                ><i class="far fa-trash-alt"></i
              ></b-button>
            </b-button-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mt-2">
            <b-modal
              :id="'menus' + el.Id"
              size="lg"
              :title="$t('menus.AddEdit.FormTitleEdit')"
              title-class="font-18"
              hide-footer
            >
              <b-tabs content-class="p-3 text-muted" v-if="AddEdit">
                <b-tab active class="border-0">
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-home"></i>
                    </span>
                    <country-flag country="tr" size="small" />
                    <span class="d-none d-sm-inline-block">Türkçe</span>
                  </template>

                  <Form @submit.prevent="onSubmit">
                    <div class="row">
                      <div class="col-md-6">
                        <forminput
                          :FormDataType="FormDataType.Title"
                          :Value="FormData.Title"
                          :v="$v.FormData.Title"
                          @input="FormData.Title = $event"
                        />
                      </div>
                      <div class="col-md-6">
                        <i
                  v-b-modal.linkfindadd
                  class="
                    position-absolute
                    top-0
                    end-0
                    mdi mdi-file-find-outline
                    me-1
                  "
                  >{{ $t("menus.AddEdit.Linkfind.Title") }}</i
                >
                        <forminput
                          :FormDataType="FormDataType.Link"
                          :Value="FormData.Link"
                          :v="$v.FormData.Link"
                          @input="FormData.Link = $event"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <formcheckbox
                          :FormDataType="FormDataType.Auth"
                          :Value="FormData.Auth"
                          :v="$v.FormData.Auth"
                          @input="FormData.Auth = $event"
                        />
                      </div>
                      <div class="col-md-6">
                        <forminput
                          :FormDataType="FormDataType.Dataorder"
                          :Value="FormData.Dataorder"
                          :v="$v.FormData.Dataorder"
                          @input="FormData.Dataorder = $event"
                        />
                      </div>
                    </div>

                    <button class="btn btn-primary" type="submit">
                      {{ $t("menus.AddEdit.Button") }}
                    </button>
                  </Form>
                </b-tab>
                <b-modal
                    id="linkfindadd"
                    size="standard"
                    :title="$t('menus.AddEdit.Linkfind.Title')"
                    title-class="font-18"
                    hide-footer
                  >
                    <div class="table-responsive">
                      <table class="table mb-0">
                        <tbody>
                          <tr v-for="(Data, index) in linkfinddata" :key="index">
                            <td>{{ Data.Type }} >> {{Data.Title}}</td>
                            <td style="width: 100px; text-align: center">
                              <b-button-group>
                                <b-button
                                  variant="success"
                                  @click="(FormData.Link = Data.Link), $bvModal.hide('linkfindadd')"
                                  ><i class="fas fa-check"></i
                                ></b-button>
                              </b-button-group>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-modal>
                <template v-for="(Data, index) in languages">
                  <b-tab :key="index" v-if="Data.Shorttitle != 'tr'">
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">
                        <country-flag :country="Data.Flag" size="small" />{{
                          Data.Title
                        }}</span
                      >
                    </template>
                    <menutranslations :DataId="FormData.Id" :LanId="Data.Id" />
                  </b-tab>
                </template>
              </b-tabs>
            </b-modal>
          </div>
        </div>
        <nested-draggable :tasks="el.Children" :TopId="el.Id" />
      </li>
    </draggable>
  </div>
  
</template> 
<script>
import draggable from "vuedraggable";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import menus from "@/models/menus";
import forminput from "../formcomponet/forminput.vue";
import formcheckbox from "../formcomponet/formcheckbox.vue";
import menutranslations from "../menutranslations/addedit.vue";
export default {
  mixins: [apibtoast, apigeneric, menus],
  props: {
    tasks: {
      required: true,
      type: Array,
    },
    TopId: String,
  },
  watch: {
    /*      TopId: function(n, o) {
            if (n !== o) {
               alert("Title updated from \"" + this.tasks[0].Title + "\" to \"" + n + "\"")
            }
        }

TopId () {
    
    
    //this.tasks[0].Topid === this.TopId 
    if(this.tasks[0]){
    alert(this.tasks[0].Id + " // " + this.TopId );
    this.tasks[0].Topid === this.TopId   
   let FormData = {
      Id:this.tasks[0].Id,
      Topid:this.TopId
    }
    alert(JSON.stringify(FormData));
    this.Update("menus", FormData);
  
  },  */
  },
  data() {
    return {
      FormData: null,
      AddEdit: null,
      languages: {},
      Test: "a",
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },
  components: {
    draggable,
    forminput,
    menutranslations,
    formcheckbox,
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("menus", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("menus");
            }
          });
        } else {
          this.Update("menus", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("menus");
            }
          });
        }
      }
    },
    Guncelle(Id) {
      this.ActionsSingleGet({ Service: "menus", Id: Id }).then((res) => {
        this.FormData = res.Data;
        this.AddEdit = "Edit";
      });
    },
    Get() {
      this.ActionsGet({ 
        Service: "menus/linkbul/8820dd51-9e5c-4442-afdc-e98786bd3365/"+window.$cookies.get("website"), 
        Page: this.Page
        }).then((res) => {
        this.linkfinddata = res.Data;
        
      });
      let Page = {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      };
      this.ActionsGet({ Service: "languages", Page: Page }).then((res) => {
        this.languages = res.Data;
      });
    },
    MenuTopId(event) { 
      if (event.added) {
        let DataId = event.added.element.Id;
        var sorgu = this.tasks.filter((notification) =>
          notification.Id.includes(DataId)
        )[0];

        sorgu.Topid = this.TopId;
        this.Update("menus", sorgu);
        // this.findId(this.tasks,DataId)
      }
      if(event.moved){
        let DataId = event.moved.element.Id;
        var sorgu2 = this.tasks.filter((notification) =>
          notification.Id.includes(DataId)
        )[0];
        sorgu2.Dataorder = event.moved.newIndex;
        this.Update("menus", sorgu2);
      }
    },
  },
  name: "nested-draggable",
};
</script>
<style scoped>
.dragArea {
  min-height: 50px;
  //outline: 1px dashed;
}
</style>